import { useEffect } from 'react';
import { connectPresence } from './connectPresence';

/** Default localStorage key for the super-app's token (mini-app-store scope). */
const DEFAULT_TOKEN_KEY = '@next-qr:mini-app-store:access_token';
const defaultGetToken = () =>
  typeof localStorage !== 'undefined' ? localStorage.getItem(DEFAULT_TOKEN_KEY) : null;

export interface PresenceClient {
  getBaseURL?: () => string | undefined;
  getAccessToken?: () => string | null | undefined;
}

/**
 * Opens the presence WebSocket for the lifetime of the calling component.
 * Call this once in the root/app component — never in a leaf component.
 *
 * Pass an `apiClient` from any generated openapi-client package to configure
 * both the base URL and the token getter automatically.
 *
 * @example
 * // No arguments — reads token from localStorage, connects to same host:
 * useConnectPresence();
 *
 * @example
 * // With a generated apiClient — uses its base URL and token getter:
 * import { apiClient as userClient } from '@next-qr/openapi-client-user';
 * useConnectPresence(userClient);
 */
export function useConnectPresence(client?: PresenceClient): void {
  useEffect(() => {

    const getToken = client?.getAccessToken ?? defaultGetToken;
    const getBaseURL = client?.getBaseURL as (() => string) | undefined;
    return connectPresence(getToken as () => string | null, { getBaseURL });
  }, [client]); // eslint-disable-line react-hooks/exhaustive-deps
}
